import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'rgbToHex'
})
export class RgbToHexPipe implements PipeTransform {
  transform(commaSeparatedRgb: string): string {
    console.log('[rgbToHex transform]', 'commaSeparatedRgb', commaSeparatedRgb);

    if (!commaSeparatedRgb) return '';

    const hex = `#${commaSeparatedRgb.split(',').map(val => parseInt(val, 10).toString(16)).join('')}`;

    console.log('hex:', hex);

    return hex;
  }
}
